import React, { useState, Fragment, useEffect } from "react";
// import styles from "./ConTrend.module.css";
import {
  Alert,
  Card,
  Col,
  Input,
  Row,
  Select,
  Spin,
  Table,
  Typography,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { fetchJsData } from "../../../../api";
import { crawl } from "../../../../api/util";
import { fetchUserSearch, newApps, cardCss, tabPageCss } from "./columns";
const { Text } = Typography;

const BulkCatChange = (props) => {
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.loader]);

  return (
    <div>
      {/* Card */}
      <Row style={{ margin: "5px", padding: "1px" }}>
        {/* <Col className="gutter-row" span={1}></Col> */}
        <Col className="gutter-row" span={23}>
          {!props.loader ? (
            <FetchTabSearch
              submit={props.submit}
              loader={props.loader}
              bulkCatData={props.bulkCatData}
              data={[]}
              col={newApps}
            />
          ) : (
            <Card
              loading={props.loader}
              style={{ width: "100%", minHeight: "80vh" }}
            ></Card>
          )}
        </Col>
      </Row>
    </div>
  );
};

const FetchTabSearch = (props) => {
  const [searchVal, setSearchVal] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [origData, setOrigData] = useState([]);
  const [searchIndex, setSearchIndex] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const { data: users } = await fetchUserSearch(props.bulkCatData["data"]);
      let id = 0;
      users.map((elem) => {
        elem.id = id++;
      });
      setOrigData(users);
      setFilteredData(users);
      const searchInd = users.map((user) => {
        const allValues = crawl(user);
        return { allValues: allValues.toString() };
      });
      setSearchIndex(searchInd);

      if (users) setLoading(false);
    };
    fetchData();
  }, [props.submit]);

  useEffect(() => {
    if (searchVal) {
      const reqData = searchIndex.map((user, index) => {
        if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0)
          return origData[index];
        return null;
      });
      setFilteredData(
        reqData.filter((user) => {
          if (user) return true;
          return false;
        })
      );
    } else setFilteredData(origData);
  }, [searchVal, origData, searchIndex, props.submit]);

  return (
    <>
      <div>
        <Row gutter={16}>
          <Col span={24}>
            <Card
              title={
                loading ? (
                  <div>
                    <Spin size="small" />
                  </div>
                ) : (
                  <Row>
                    <Row>
                      <Col spane={6}>
                        <Text style={{ wordWrap: "break-word" }}>
                          {
                            "The categories of apps/domains listed below have been reviewed to determine a more specific and accurate categorization."
                          }
                        </Text>
                      </Col>
                    </Row>
                    <Row>
                      <Col spane={6}>
                        <Text style={{ wordWrap: "break-word" }}>
                          {
                            "The updated categories will come into affect as per the specified release."
                          }
                        </Text>
                      </Col>
                    </Row>
                  </Row>
                )
              }
              loading={props.loader}
              size="small"
              // style={{ maxHeight: "80vh", overflow: "scroll" }}
              style={{ minHeight: "80vh" }}
              // bodyStyle={{ padding: "0", borderStyle: "hidden" }}
              bodyStyle={cardCss}
              headStyle={{ backgroundColor: "#F0F8FF", border: 0 }}
              extra={
                <Row>
                  <Col span={21}>
                    <Input
                      onChange={(e) => setSearchVal(e.target.value)}
                      prefix={
                        <SearchOutlined className="site-form-item-icon" />
                      }
                      placeholder="Crawl Search"
                      allowClear
                    />
                  </Col>
                  <Col span={1}></Col>
                  <Col className="gutter-row" span={2}>
                    {" "}
                    <div></div>
                  </Col>
                </Row>
              }
            >
              <Fragment>
                <Table
                  rowKey="id"
                  size="small"
                  bordered
                  scroll={{ x: 550, y: 900 }}
                  style={{ margin: "2px" }}
                  dataSource={filteredData}
                  columns={props.col(filteredData.length)}
                  loading={loading}
                  pagination={{
                    pageSizeOptions: ["10", "30", "60", "100", "1000"],
                    defaultPageSize: ["50"],
                    showSizeChanger: true,
                    // style: { padding: "0", marginBottom: "0" },
                    style: tabPageCss,
                  }}
                />
              </Fragment>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default BulkCatChange;
